module.exports = "https://la-static.vkplay.ru/promo/universal/img/card1.65c068eb.jpg";